// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-content-wrapper {
	display: flex;
	flex-direction: column;
	gap: 60px;
	max-width: 960px;
	width: 100%;
	padding: 120px 0;
}

.faq-title-block {
	display: flex;
	flex-direction: column;
	align-items: start;
	width: 100%;
	gap: 16px;
}

.faq-title {
	font-size: 48px;
	line-height: 48px;
	font-family: "Poppins", sans-serif;
	color: var(--dark);
	max-width: 640px;
	font-weight: 400;
}

.faq-description {
	font-size: 20px;
	line-height: 24px;
	font-family: "Poppins", sans-serif;
	color: var(--secondary-text);
	max-width: 670px;
}

.faq-questions-list {
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
}

.faq-question-item {
	min-height: 70px;
	width: 100%;
	background-color: var(--background-light);
	border-radius: 6px;
	display: grid;
	grid-template-columns: 50px 1fr 50px;
	padding: 24px 30px;
	cursor: pointer;
	transition: 0.3s;
}

.faq-question-circle {
	width: 26px;
	height: 26px;
	border-radius: 50%;
	background-color: transparent;
	display: flex;
	justify-content: center;
	align-items: center;
	border: 1px solid var(--dark);
	transition: 0.3s;
}

.faq-question-content {
	display: flex;
	flex-direction: column;
	gap: 30px;
}

.faq-question-title {
	font-size: 22px;
	line-height: 26px;
	font-family: "Poppins", sans-serif;
	color: var(--dark);
	font-weight: 400;
	padding-top: 4px;
}

.faq-question-item-wrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.faq-question-icon {
	display: flex;
	justify-content: flex-end;
	margin-top: -2px;
}

.faq-question-plus-icon {
	display: block;
}

.faq-question-minus-icon {
	display: none;
}

.faq-question-item.expanded .faq-question-minus-icon {
	display: block;
}

.faq-question-item.expanded .faq-question-plus-icon {
	display: none;
}

.faq-question-description {
	display: none;
	font-family: "Poppins", sans-serif;
	color: var(--dark);
	line-height: 20px;
	margin-top: 16px;
	font-weight: 300;
	font-size: 18px;
	position: relative;
	padding: 8px 0;
	transition: 0.3s;
}

.faq-question-item.expanded .faq-question-description {
	display: block;
}

.faq-question-description-line {
	position: absolute;
	left: -38px;
	top: 0;
	height: 100%;
	width: 1px;
	background-color: var(--dark);
}

.faq-question-circle-wrapper {
	margin-top: 3px;
}

.faq-link {
	color: var(--dark) !important;
	text-decoration: underline !important;
}

@media (max-width: 950px) {
	.faq-content-wrapper {
		display: flex;
		flex-direction: column;
		gap: 30px;
		max-width: 960px;
		width: 100%;
		padding: 40px 0;
	}

	.faq-title {
		font-size: 32px;
		line-height: 32px;
		font-family: "Poppins", sans-serif;
		color: var(--dark);
		max-width: 640px;
		font-weight: 400;
	}

	.faq-description {
		font-size: 16px;
		line-height: 20px;
		font-family: "Poppins", sans-serif;
		color: var(--secondary-text);
		max-width: 670px;
	}

	.faq-questions-list {
		display: flex;
		flex-direction: column;
		gap: 16px;
		width: 100%;
	}

	.faq-question-item {
		min-height: 70px;
		width: 100%;
		background-color: var(--background-light);
		border-radius: 6px;
		display: grid;
		grid-template-columns: 40px 1fr 40px;
		padding: 12px 16px;
		cursor: pointer;
		transition: 0.3s;
	}

	.faq-question-content {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.faq-question-title {
		font-size: 18px;
		line-height: 22px;
		font-family: "Poppins", sans-serif;
		color: var(--dark);
		font-weight: 400;
		padding-top: 5px;
	}

	.faq-question-description {
		display: none;
		font-family: "Poppins", sans-serif;
		color: var(--dark);
		line-height: 18px;
		margin-top: 16px;
		font-weight: 300;
		font-size: 15px;
		position: relative;
		padding: 8px 0;
		transition: 0.3s;
		word-break: break-word;
	}

	.faq-question-plus-icon {
		display: block;
		width: 28px;
	}

	.faq-question-minus-icon {
		display: none;
		width: 28px;
	}

	.faq-question-circle {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background-color: transparent;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid var(--dark);
		transition: 0.3s;
		margin-top: 2px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/LendingPage/FAQ/FAQ.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,gBAAgB;CAChB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,kBAAkB;CAClB,WAAW;CACX,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,4BAA4B;CAC5B,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,yCAAyC;CACzC,kBAAkB;CAClB,aAAa;CACb,oCAAoC;CACpC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,6BAA6B;CAC7B,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,6BAA6B;CAC7B,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,kCAAkC;CAClC,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,MAAM;CACN,YAAY;CACZ,UAAU;CACV,6BAA6B;AAC9B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,6BAA6B;CAC7B,qCAAqC;AACtC;;AAEA;CACC;EACC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;CACZ;;CAEA;EACC,gBAAgB;EAChB,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,SAAS;CACV;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;CACvB;;CAEA;EACC,cAAc;EACd,WAAW;CACZ;;CAEA;EACC,aAAa;EACb,WAAW;CACZ;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;CAChB;AACD","sourcesContent":[".faq-content-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 60px;\n\tmax-width: 960px;\n\twidth: 100%;\n\tpadding: 120px 0;\n}\n\n.faq-title-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: start;\n\twidth: 100%;\n\tgap: 16px;\n}\n\n.faq-title {\n\tfont-size: 48px;\n\tline-height: 48px;\n\tfont-family: \"Poppins\", sans-serif;\n\tcolor: var(--dark);\n\tmax-width: 640px;\n\tfont-weight: 400;\n}\n\n.faq-description {\n\tfont-size: 20px;\n\tline-height: 24px;\n\tfont-family: \"Poppins\", sans-serif;\n\tcolor: var(--secondary-text);\n\tmax-width: 670px;\n}\n\n.faq-questions-list {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n\twidth: 100%;\n}\n\n.faq-question-item {\n\tmin-height: 70px;\n\twidth: 100%;\n\tbackground-color: var(--background-light);\n\tborder-radius: 6px;\n\tdisplay: grid;\n\tgrid-template-columns: 50px 1fr 50px;\n\tpadding: 24px 30px;\n\tcursor: pointer;\n\ttransition: 0.3s;\n}\n\n.faq-question-circle {\n\twidth: 26px;\n\theight: 26px;\n\tborder-radius: 50%;\n\tbackground-color: transparent;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder: 1px solid var(--dark);\n\ttransition: 0.3s;\n}\n\n.faq-question-content {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 30px;\n}\n\n.faq-question-title {\n\tfont-size: 22px;\n\tline-height: 26px;\n\tfont-family: \"Poppins\", sans-serif;\n\tcolor: var(--dark);\n\tfont-weight: 400;\n\tpadding-top: 4px;\n}\n\n.faq-question-item-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n}\n\n.faq-question-icon {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tmargin-top: -2px;\n}\n\n.faq-question-plus-icon {\n\tdisplay: block;\n}\n\n.faq-question-minus-icon {\n\tdisplay: none;\n}\n\n.faq-question-item.expanded .faq-question-minus-icon {\n\tdisplay: block;\n}\n\n.faq-question-item.expanded .faq-question-plus-icon {\n\tdisplay: none;\n}\n\n.faq-question-description {\n\tdisplay: none;\n\tfont-family: \"Poppins\", sans-serif;\n\tcolor: var(--dark);\n\tline-height: 20px;\n\tmargin-top: 16px;\n\tfont-weight: 300;\n\tfont-size: 18px;\n\tposition: relative;\n\tpadding: 8px 0;\n\ttransition: 0.3s;\n}\n\n.faq-question-item.expanded .faq-question-description {\n\tdisplay: block;\n}\n\n.faq-question-description-line {\n\tposition: absolute;\n\tleft: -38px;\n\ttop: 0;\n\theight: 100%;\n\twidth: 1px;\n\tbackground-color: var(--dark);\n}\n\n.faq-question-circle-wrapper {\n\tmargin-top: 3px;\n}\n\n.faq-link {\n\tcolor: var(--dark) !important;\n\ttext-decoration: underline !important;\n}\n\n@media (max-width: 950px) {\n\t.faq-content-wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 30px;\n\t\tmax-width: 960px;\n\t\twidth: 100%;\n\t\tpadding: 40px 0;\n\t}\n\n\t.faq-title {\n\t\tfont-size: 32px;\n\t\tline-height: 32px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tcolor: var(--dark);\n\t\tmax-width: 640px;\n\t\tfont-weight: 400;\n\t}\n\n\t.faq-description {\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tcolor: var(--secondary-text);\n\t\tmax-width: 670px;\n\t}\n\n\t.faq-questions-list {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 16px;\n\t\twidth: 100%;\n\t}\n\n\t.faq-question-item {\n\t\tmin-height: 70px;\n\t\twidth: 100%;\n\t\tbackground-color: var(--background-light);\n\t\tborder-radius: 6px;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 40px 1fr 40px;\n\t\tpadding: 12px 16px;\n\t\tcursor: pointer;\n\t\ttransition: 0.3s;\n\t}\n\n\t.faq-question-content {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 12px;\n\t}\n\n\t.faq-question-title {\n\t\tfont-size: 18px;\n\t\tline-height: 22px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tcolor: var(--dark);\n\t\tfont-weight: 400;\n\t\tpadding-top: 5px;\n\t}\n\n\t.faq-question-description {\n\t\tdisplay: none;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tcolor: var(--dark);\n\t\tline-height: 18px;\n\t\tmargin-top: 16px;\n\t\tfont-weight: 300;\n\t\tfont-size: 15px;\n\t\tposition: relative;\n\t\tpadding: 8px 0;\n\t\ttransition: 0.3s;\n\t\tword-break: break-word;\n\t}\n\n\t.faq-question-plus-icon {\n\t\tdisplay: block;\n\t\twidth: 28px;\n\t}\n\n\t.faq-question-minus-icon {\n\t\tdisplay: none;\n\t\twidth: 28px;\n\t}\n\n\t.faq-question-circle {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tborder-radius: 50%;\n\t\tbackground-color: transparent;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder: 1px solid var(--dark);\n\t\ttransition: 0.3s;\n\t\tmargin-top: 2px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
